import { Divider, Radio, Table } from 'antd';
// import type { ColumnsType } from "antd/es/table";
import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router';

interface Props {
  // Loading
  loading: boolean;
  getLogisticProductList: Function;
  rowDataProducts: any;
  totalProduct: number;
  selectedLogisticProduct: React.Key[];
  setSelectedLogisticProduct: React.Dispatch<React.SetStateAction<React.Key[]>>;
  handleChangePageSellerProduct: Function;
}

const columns = [
  {
    title: 'No',
    dataIndex: 'no',
    key: 'no'
  },
  {
    title: '셀러 ID',
    dataIndex: 'email',
    key: 'email'
  },
  {
    title: '셀러명',
    dataIndex: 'name',
    key: 'name'
  },
  {
    title: '상품명',
    dataIndex: 'productName',
    key: 'productName'
  },
  {
    title: 'SKU',
    dataIndex: 'sku',
    key: 'sku'
  },
  {
    title: '수량',
    dataIndex: 'quantity',
    key: 'quantity'
  },
  {
    title: '적재 위치',
    dataIndex: 'loadingPlace',
    key: 'loadingPlace'
  }
];

const LogisticCenterProductTable = ({
  loading,
  rowDataProducts,
  totalProduct,
  selectedLogisticProduct,
  setSelectedLogisticProduct,
  handleChangePageSellerProduct
}: Props) => {
  const onSelectChange = (newSelectedRowKeys: React.Key[]) => {
    setSelectedLogisticProduct(newSelectedRowKeys);
  };
  const rowSelection = {
    selectedLogisticProduct,
    onChange: onSelectChange
  };

  return (
    <div>
      <Table
        className="busk-table"
        rowSelection={rowSelection}
        loading={loading}
        columns={columns}
        dataSource={rowDataProducts}
        pagination={{
          pageSize: 10,
          total: totalProduct,
          onChange: (newPage) => {
            handleChangePageSellerProduct(newPage);
          }
        }}
      />
    </div>
  );
};

export default LogisticCenterProductTable;
